import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import {
  getClubBookingSessionList,
  getClubBookingSelectedSession,
  isClubBookingDayBooked,
  isClubBookingDayHoliday,
  isClubBookingDayFull,
  isClubBookingInBasket,
  isClubBookingDayExpired
} from "state/school_money/selectors";
import { selectClubBookingSession } from "state/school_money/actions";

import Currency from "components/Currency";
import Dropdown from "components/Dropdown";

import "./DailyClubSessionInput.css";

class DailyClubSessionInput extends React.Component {
  
  onClick = event => {
    // trigger the alert if we're in the basket but would be selectable otherwise
    if (this.isReadOnly() && !this.isDisabled()) {
      this.props.onReadOnlyClick(event);
    }
  }
  
  onSessionSelected = sessionID => {
    if (sessionID !== null) {
      sessionID = Number(sessionID);
    }
    this.props.selectSession(sessionID);
  }
  
  isDisabled() {
    const { isBooked, isHoliday, isFull, isExpired } = this.props;
    return isHoliday || (isFull && !isBooked) || isExpired;
  }
  
  isReadOnly() {
    return this.props.isInBasket;
  }
  
  isSessionSelected() {
    return this.props.selectedSession !== undefined;
  }
  
  /**
   * NB: Dropdown requires IDs as strings, so we need to convert back and forth
   */
  renderDropdown() {
    const { sessionList, selectedSession } = this.props;
    const selectedSessionID = this.isSessionSelected() ? selectedSession.get("id") : "";
    return (
      <Dropdown
        cssModifier="school_money"
        options={sessionList}
        selectedOptionID={selectedSessionID.toString()}
        onChange={this.onSessionSelected}
        placeholder="No Selection"
        disabled={this.isDisabled()}
        readOnly={this.isReadOnly()}
      />
    )
  }
  
  render() {
    
    const { weekdayName, isFull, selectedSession } = this.props;
    const sessionPrice = this.isSessionSelected() ? selectedSession.get("price") : 0;
    const showFull = this.isDisabled() && isFull;
    
    const classNames = [ "daily-session-input" ];
    if (this.isDisabled()) {
      classNames.push("daily-session-input--disabled");
    }
    
    return (
      <tr className={classNames.join(" ")} onClick={this.onClick}>
        <td className="daily-session-input__weekday">{ weekdayName }</td>
        <td className="daily-session-input__input">
          { this.renderDropdown() }
          { showFull ? <div className="daily-session-input__full">FULL</div> : null }
        </td>
        <td className="daily-session-input__price">
          <Currency amount={sessionPrice} />
        </td>
      </tr>
    )
    
  }
  
}

export default connect(
  (state, { clubBookingID, weekdayIndex }) => ({
    sessionList: getClubBookingSessionList(state, clubBookingID, weekdayIndex),
    selectedSession: getClubBookingSelectedSession(state, clubBookingID, weekdayIndex),
    isBooked: isClubBookingDayBooked(state, clubBookingID, weekdayIndex),
    isHoliday: isClubBookingDayHoliday(state, clubBookingID, weekdayIndex),
    isFull: isClubBookingDayFull(state, clubBookingID, weekdayIndex),
    isInBasket: isClubBookingInBasket(state, clubBookingID),
    isExpired: isClubBookingDayExpired(state, clubBookingID, weekdayIndex)
  }),
  (dispatch, { clubBookingID, weekdayIndex }) => bindActionCreators({
    selectSession: sessionID => selectClubBookingSession(clubBookingID, weekdayIndex, sessionID)
  }, dispatch)
)(DailyClubSessionInput);



// WEBPACK FOOTER //
// ./src/components/school_money/clubs/DailyClubSessionInput.js